// src/components/Navbar.jsx
// Navbar component for all pages of webapp

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/SandCherry_CatalizeResults.png";
import linkedInLogo from "../images/linkedin-logo-3.png";
import websiteLogo from "../images/sca_logo.jpeg";
import ytLogo from "../images/yt.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
    setOpen((previousValue) => !previousValue);
  };

  const closeMenu = () => {
    setOpen(false);
  };

  const linkClass = ({ isActive }) =>
    isActive
      ? "font-bold transform transition-transform hover:scale-110 text-white hover:text-white rounded-md px-3 py-2"
      : "transform transition-transform hover:scale-110 text-white hover:text-white rounded-md px-3 py-2";

  return (
    <>
      <nav className="bg-sky-950 border-b">
        <div className="mx-0 px-1 sm:px-1 lg:px-1 w-full">
          <div className="flex h-20 items-center justify-between mx-0 w-full px-1 sm:px-1 lg:px-1">
            <div className="flex flex-1 items-center justify-center">
              <NavLink
                className="flex flex-shrink-0 items-center mr-4"
                to="/"
                onClick={closeMenu}
              >
                <img
                  className="h-10 w-auto"
                  src={logo}
                  alt="Sand Cherry Logo"
                />
              </NavLink>

              <div className="ml-auto">
                {/* Elements for larger screens */}
                <div className="hidden items-center space-x-2 sm:flex">
                  <div className="flex space-x-2">
                    <NavLink to="/" className={linkClass}>
                      Home
                    </NavLink>

                    <NavLink to="/schedule" className={linkClass}>
                      Schedule
                    </NavLink>

                    <NavLink to="/directory" className={linkClass}>
                      Directory
                    </NavLink>

                    <NavLink to="/map" className={linkClass}>
                      Map
                    </NavLink>
                  </div>

                  <div>
                    <a
                      href="https://www.sandcherryassociates.com/"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Sand Cherry website"
                      title="Sand Cherry website"
                    >
                      <img
                        className="h-8 w-auto rounded"
                        src={websiteLogo}
                        alt="Website"
                      />
                    </a>
                  </div>

                  <div>
                    <a
                      href="https://www.linkedin.com/company/sand-cherry-associates/mycompany/verification/"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Sand Cherry LinkedIn"
                      title="LinkedIn"
                    >
                      <img
                        className="h-8 w-auto"
                        src={linkedInLogo}
                        alt="LinkedIn"
                      />
                    </a>
                  </div>

                  <div>
                    <a
                      href="https://www.youtube.com/@sandcherry6122"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Sand Cherry YouTube"
                      title="YouTube"
                    >
                      <img
                        className="h-8 w-auto"
                        src={ytLogo}
                        alt="YouTube"
                      />
                    </a>
                  </div>
                </div>

                {/* Menu button for small screens */}
                <div className="sm:hidden">
                  <button
                    type="button"
                    onClick={toggleMenu}
                    className="text-white focus:outline-none"
                    aria-label={open ? "Close navigation menu" : "Open navigation menu"}
                    aria-expanded={open}
                    aria-controls="mobile-navigation"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="menu h-6 w-6"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M2 5a1 1 0 011-1h14a1 1 0 110 2H3a1 1 0 01-1-1zm0 5a1 1 0 011-1h14a1 1 0 110 2H3a1 1 0 01-1-1zm0 5a1 1 0 011-1h14a1 1 0 110 2H3a1 1 0 01-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Drop-down navigation for small screens */}
      {open && (
        <div
          id="mobile-navigation"
          className="fixed left-0 top-20 z-50 w-full bg-sky-950 shadow-lg sm:hidden"
        >
          <div className="items-center justify-center border border-solid border-sky-900 bg-sky-950 py-3 hover:bg-sky-800">
            <NavLink to="/" className={linkClass} onClick={closeMenu}>
              Home
            </NavLink>
          </div>

          <div className="items-center justify-center border border-solid border-sky-900 bg-sky-950 py-3 hover:bg-sky-800">
            <NavLink
              to="/schedule"
              className={linkClass}
              onClick={closeMenu}
            >
              Schedule
            </NavLink>
          </div>

          <div className="items-center justify-center border border-solid border-sky-900 bg-sky-950 py-3 hover:bg-sky-800">
            <NavLink
              to="/directory"
              className={linkClass}
              onClick={closeMenu}
            >
              Directory
            </NavLink>
          </div>

          <div className="items-center justify-center border border-solid border-sky-900 bg-sky-950 py-3 hover:bg-sky-800">
            <NavLink to="/map" className={linkClass} onClick={closeMenu}>
              Map
            </NavLink>
          </div>

          <div className="items-center justify-center border border-solid border-sky-900 bg-sky-950 py-3 hover:bg-sky-800">
            <a
              href="https://www.sandcherryassociates.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Sand Cherry website"
              title="Sand Cherry website"
            >
              <img
                className="ml-3 h-8 w-auto pl-3 rounded"
                src={websiteLogo}
                alt="Website"
              />
            </a>
          </div>

          <div className="items-center justify-center border border-solid border-sky-900 bg-sky-950 py-3 hover:bg-sky-800">
            <a
              href="https://www.linkedin.com/company/sand-cherry-associates/mycompany/verification/"
              target="_blank"
              rel="noreferrer"
              aria-label="Sand Cherry LinkedIn"
              title="LinkedIn"
            >
              <img
                className="ml-3 h-8 w-auto pl-3"
                src={linkedInLogo}
                alt="LinkedIn"
              />
            </a>
          </div>

          <div className="items-center justify-center border border-solid border-sky-900 bg-sky-950 py-3 hover:bg-sky-800">
            <a
              href="https://www.youtube.com/@sandcherry6122"
              target="_blank"
              rel="noreferrer"
              aria-label="Sand Cherry YouTube"
              title="YouTube"
            >
              <img
                className="ml-3 h-8 w-auto pl-3"
                src={ytLogo}
                alt="YouTube"
              />
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;